import { I18n } from "@lingui/core";
import { t } from "@lingui/macro";
import { Link } from "./";

export enum Route {
  Root = "/sitedetails",
  Details = "/sitedetails/details",
  Rules = "/sitedetails/rules",
  Template = "/sitedetails/templates",
}

export const links: Link[] = [
  {
    label: (i18n: I18n) => { return typeof i18n._ === "function" ? i18n._(t("site_details.details")`Details`) : "Details"},
    href: Route.Details,
  },
  {
    label: (i18n: I18n) => { return typeof i18n._ === "function" ? i18n._(t("site_details.rules")`Rule Hits`) : "Rule Hits"},
    href: Route.Rules,
  },
  {
    label: (i18n: I18n) => { return typeof i18n._ === "function" ? i18n._(t("site_details.templates")`Templates`) : "Templates"},
    href: Route.Template,
  },
];

export const SiteDetailLinks = !process.env.BETA
  ? links.filter((l) => !l.isBeta)
  : links;
